"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFlameFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22 10.85c-.41-.49-.82-1-1.18-1.45A27.08 27.08 0 0117 2.68l-.53-1.57-1.14 1.2C14.9 2.71 6 12.15 6 20a10 10 0 0020 0c0-4.4-2.23-7-4-9.15zM16 28a4.08 4.08 0 01-4-4.15c0-3.48 4-7.85 4-7.85s4 4.15 4 7.85A4.08 4.08 0 0116 28z" })));
}
exports.default = SvgFlameFilled;
//# sourceMappingURL=FlameFilled.js.map